var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconRover = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 16,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.656 13.625a1.406 1.406 0 1 1-2.812 0 1.406 1.406 0 0 1 2.812 0m0 0h6.563m-6.563 0V7.939m6.563 5.686a1.406 1.406 0 1 0 2.811 0 1.406 1.406 0 0 0-2.811 0m1.344-1.405.473-3.419a1.13 1.13 0 0 0-2.23-.362l-.703 2.842H9.406a.937.937 0 0 0-.937.938v.469a.937.937 0 0 0 .937.937h.938M1.25 3.495a2.62 2.62 0 0 1 1.569-2.34 2.62 2.62 0 0 1 2.763.546m-.854 1.2a1.2 1.2 0 0 0-1.312-.303 1.2 1.2 0 0 0-.713 1.141m5.195-.122c.793 1.914-.355 3.53-2.269 4.322-1.913.793-3.868.462-4.66-1.452z"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 16,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: fill,
    stroke: stroke,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.656 13.625a1.406 1.406 0 1 1-2.812 0 1.406 1.406 0 0 1 2.812 0m0 0h6.563m-6.563 0V7.939m6.563 5.686a1.406 1.406 0 1 0 2.811 0 1.406 1.406 0 0 0-2.811 0m1.344-1.405.473-3.419a1.13 1.13 0 0 0-2.23-.362l-.703 2.842H9.406a.937.937 0 0 0-.937.938v.469a.937.937 0 0 0 .937.937h.938M1.25 3.495a2.62 2.62 0 0 1 1.569-2.34 2.62 2.62 0 0 1 2.763.546m-.854 1.2a1.2 1.2 0 0 0-1.312-.303 1.2 1.2 0 0 0-.713 1.141m5.195-.122c.793 1.914-.355 3.53-2.269 4.322-1.913.793-3.868.462-4.66-1.452z"
  }));
});
export default SvgIconRover;
export const raw = __webpack_public_path__ + "static/media/IconRover.955b822a676a0e8ecfcc98f4db9f88eb.svg";